import React, { useCallback, useRef, useState } from "react";

/**
 * BeforeAfter — a lightweight before/after image slider.
 * Uses width % of an inner wrapper to reveal the "after" image.
 */
const BeforeAfter = ({ before, after, labelBefore = "Before", labelAfter = "After", testid = "before-after" }) => {
  const [pos, setPos] = useState(50);
  const wrapRef = useRef(null);
  const dragging = useRef(false);

  const updateFromEvent = useCallback((clientX) => {
    const el = wrapRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPos((x / rect.width) * 100);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromEvent(cx);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromEvent(cx);
  };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      data-testid={testid}
      ref={wrapRef}
      className="ba-slider"
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      <img src={after} alt={labelAfter} className="before" />
      <div className="after-wrap" style={{ width: `${pos}%` }}>
        <img src={before} alt={labelBefore} className="after" />
      </div>
      <div className="ba-handle" style={{ left: `${pos}%` }} />
      <span className="absolute top-3 left-3 overline text-white/90 mix-blend-difference">{labelBefore}</span>
      <span className="absolute top-3 right-3 overline text-white/90 mix-blend-difference">{labelAfter}</span>
    </div>
  );
};

export default BeforeAfter;
